import { HttpContextToken } from '@angular/common/http';

export const SKIP_DSDN_AUTH = new HttpContextToken<boolean>(() => false);
